<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col>
            <a-form-item label="年级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="model.gradeName" placeholder="请输入年级名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="年级主任名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                show-search
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                v-model="model.headteacherId"
                placeholder="请选择年级主任"
                @search="handleUserSearch"
                @change="handleUserChange"
                allowClear
              >
                <a-select-option v-for="d in userData" :key="d.id">
                  {{ d.realname }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sortOrder']" placeholder="请输入排序"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="Object.keys(this.model).length" :span="24">
            <a-form-item label="心情阈值" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div class="flex-center">
                <a-input-number
                  v-decorator="['threshold']"
                  placeholder="请输入心情阈值"
                  style="flex: 1"
                  @change="getThresholdNum"
                />
                <div class="thresholdText">
                  大约有
                  <a-spin v-if="thresholdLoading" style="margin: 0 5px" />
                  <span v-else style="color: #1890ff; font-weight: bold">{{ thresholdValue }}</span>
                  人
                </div>
              </div>
            </a-form-item>
          </a-col>
          <a-col v-has="'virtualGrade:show'" :span="24">
            <a-form-item label="是否为虚拟年级" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-switch v-model="model.isVirtual" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
import { getAction, httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import JFormContainer from '@/components/jeecg/JFormContainer'
import Vue from 'vue'
import { TENANT_ID } from '@/store/mutation-types'
import { simpleDebounce } from '@/utils/util'

export default {
  name: 'StudentGradeForm',
  components: {
    JFormContainer,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      model: {},
      userData: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/aigoes/schoolGrade/add',
        edit: '/aigoes/schoolGrade/edit',
        queryById: '/aigoes/schoolGrade/queryById',
      },
      thresholdValue: 0, // 阈值人数
      thresholdLoading: false,
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.thresholdValue = 0
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'sortOrder', 'gradeName', 'headteacherId', 'teacherName', 'threshold')
        )
      })
      this.handleUserSearch('', this.model)
      if (this.model.threshold) {
        this.getThresholdNum(this.model.threshold)
      }
    },

    submitForm() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(
            { ...this.model, isVirtual: this.model.isVirtual ? 1 : 0 },
            values
          )
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    /**
     * 查询老师
     * @param val
     * @param name
     */
    handleUserSearch(val, initData) {
      getAction('/sys/user/list', {
        realname: '*' + val + '*',
        userIdentity_FindInSet: '2',
        relTenantIds_FindInSet: Number(Vue.ls.get(TENANT_ID)),
      }).then((res) => {
        this.userData = res.result.records
        if (initData.headteacherId) {
          this.userData.push({ id: initData.headteacherId, realname: initData.teacherName })
        }
      })
    },
    /**
     * 修改班主任
     * @param value
     */
    handleUserChange(val) {
      console.log('清空--', val)
      if (!val) {
        this.model.headteacherId = ''
      }
      this.userData.forEach((item) => {
        if (item.id === val) {
          this.model.teacherName = item.realname
        }
      })
    },
    // 修改阈值获取人数
    getThresholdNum: simpleDebounce(function (val) {
      this.thresholdLoading = true
      console.log('记录:', this.model)
      console.log('搜索条件--', val)
      getAction('/aigoes/schoolGrade/getReminderCount', {
        gradeId: this.model.id,
        threshold: val,
      })
        .then((res) => {
          if (res.success) {
            this.thresholdValue = res.result
          }
        })
        .finally(() => {
          this.thresholdLoading = false
        })
    }, 600),
  },
}
</script>
<style scoped lang="less">
.thresholdText {
  width: 100px;
  margin-left: 10px;
  background: #fafafa;
  text-align: center;
  border-radius: 6px;
}
</style>
